import Vue from 'vue'

export default el => new Vue({
  name: 'Two Image',
  el
})
